import TripPanel from "./TripPanel"

export default  TripPanel;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/index.js